<template>
  <div class="grid" @animationend="handleAnimationOverflow">
    <div v-if="col1Slot" class="col-1 col">
      <slot name="col-1"></slot>
    </div>
    <div v-if="col2Slot" class="col-2 col">
      <slot name="col-2"></slot>
    </div>
    <div v-if="col3Slot" class="col-3 col">
      <slot name="col-3"></slot>
    </div>
    <div v-if="defaultSlot" class="col-1-3 col">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Grid',
  props: {
    slideTag: String,
    fullpage: Object
  },
  computed: {
    col1Slot: function () {
      return !!this.$slots['col-1']
    },
    col2Slot: function () {
      return !!this.$slots['col-2']
    },
    col3Slot: function () {
      return !!this.$slots['col-3']
    },
    defaultSlot: function () {
      return !!this.$slots.default
    }
  },
  methods: {
    animateCols: function (origin, destination, direction) {
      if (destination.anchor === this.slideTag) {
        const cols = destination.item.querySelectorAll('.col')
        this.$el.style.overflowY = 'hidden'

        if (direction === 'down') {
          cols.forEach(function (col) {
            if (col.classList.contains('col-3')) {
              col.classList.add('col_slidein1')
            } else if (col.classList.contains('col-2')) {
              col.classList.add('col_slidein2')
            } else {
              col.classList.add('col_slidein3')
            }
          })
        } else {
          cols.forEach(function (col) {
            if (col.classList.contains('col-3')) {
              col.classList.add('col_slidein3')
            } else if (col.classList.contains('col-2')) {
              col.classList.add('col_slidein2')
            } else {
              col.classList.add('col_slidein1')
            }
          })
        }
      } else {
        origin.item.querySelectorAll('.col').forEach(function (col) {
          col.classList.remove('col_slidein1', 'col_slidein2', 'col_slidein3')
        })
      }
    },
    handleAnimationOverflow: function (e) {
      this.$el.style.overflowY = 'visible'
    }
  },
  mounted: function () {
    this.$emit('animationCallbackReady', this.animateCols)
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.grid {
  width: 100%;
  min-height: 80%;
}

.col-1-3 {
  width: 100%;
}

.col {
  padding-bottom: 0.5em;
  overflow: hidden;
  will-change: transform;
}

.col_slidein1 {
  animation: slidein1 750ms 250ms;
}

.col_slidein2 {
  animation: slidein2 750ms 250ms;
}

.col_slidein3 {
  animation: slidein3 750ms 250ms;
}

@keyframes slidein1 {
  from {
    transform: translateY(5em);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes slidein2 {
  from {
    transform: translateY(7.5em);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes slidein3 {
  from {
    transform: translateY(10em);
  }

  to {
    transform: translateY(0);
  }
}

@include md-screen {
  .grid {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .col-1,
  .col-2 {
    width: 48%;
  }

  .col-3 {
    width: 100%;
  }
}

@include lg-screen {
  .grid {
    justify-content: flex-start;
  }

  .col-1 {
    width: 25%;
  }

  .col-2 {
    width: 33.33%;
  }

  .col-3 {
    width: 41.67%;
  }
}
</style>
